import { gql } from '@apollo/client'

export const Query = gql`
  query IntegrationProviderCategories(
    $companyId: ID!
  ) {
    integrationProviderCategories(companyId: $companyId, filters: {}, order: { name: asc }) {
      id
      name
      integrationProviders(order: { type: asc }) {
        id
        displayName
        image { url }
        description
        integrations {
          id
        }
        ... on IntegrationProvidersFreeagent {
          authorizeAppUrl
        }
        ... on IntegrationProvidersXero {
          authorizeAppUrl
        }
        ... on IntegrationProvidersMystro {
          authorizeAppUrl
        }
      }
    }
  }
`
